import icImportSuccess from 'assets/images/ic-import-success.svg'
import { useNavigate } from 'react-router-dom'
import { Button, Modal } from 'avo-ui'
import Tooltip from 'components/commons/tooltip'
import icError from 'assets/images/ic-error.svg'

export const Done = ({ importResult, showError, setShowErrorHandler, skippedMessage }) => {
    const navigate = useNavigate()

    return (
        <div className={'w-5/6 flex flex-col gap-y-4 border rounded-lg'}>
            <div className={'flex flex-col items-center space-y-4 border-b py-10'}>
                <img src={icImportSuccess} alt='ic-import-success' className={'w-40'} />
                <p className={'text-lg text-blue-90'}>Import Complete</p>
                <p className={'text-neutral-80'}>
                    Terdapat <span className={'font-bold'}>{importResult?.statistics?.total_valid || 0}</span> Product
                    di impor dan <span className={'font-bold'}>{importResult?.statistics?.total_invalid || 0}</span>{' '}
                    Product error
                </p>
                {(importResult?.statistics?.total_invalid || skippedMessage() || importResult?.invalid_ids?.length) && (
                    <Button
                        type='outline'
                        title='Error/Warning Detail'
                        icon={icError}
                        onClick={() => setShowErrorHandler(true)}
                    />
                )}
            </div>
            <div className={'flex pb-4 justify-center'}>
                <Button
                    className={'w-fit px-8'}
                    title={'View Product List'}
                    onClick={() => navigate('/product/product-list')}
                />
            </div>
            <Modal
                dialogClassName={'max-w-[470px]'}
                contentClassName={'rounded-xl overflow-auto'}
                show={showError}
                onHide={() => setShowErrorHandler(false)}
            >
                <>
                    <div className={'flex flex-col space-y-4 p-10 text-neutral-70'}>
                        <div className={'flex flex-col space-y-4 items-center'}>
                            <img src={icError} alt={'ic-error'} className={'w-12 h-12'} />
                            <p className={'font-semibold'}>Error/Warning</p>
                        </div>
                        {!!importResult?.excel_error?.length && (
                            <div className={'flex flex-col space-y-4'}>
                                {importResult?.excel_error?.map((item, index) => (
                                    <div key={index}>
                                        {`Terjadi error pada baris ${item?.row} excel`}
                                        {Object?.keys(item?.errors)?.map((key, i) => (
                                            <div key={i}>{`- ${key}: ${item?.errors[key]}`}</div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        )}
                        {!!skippedMessage()?.length && (
                            <Tooltip
                                className={'w-fit pr-2 whitespace-pre-wrap'}
                                content={'Error input kategori/type product'}
                                text={skippedMessage()}
                                position={'right'}
                            />
                        )}
                        {!!importResult?.invalid_ids?.length && (
                            <Tooltip
                                className={'w-fit pr-2 whitespace-pre-wrap'}
                                content={'Error update product'}
                                text={`Invalid ID: \n ${importResult?.invalid_ids?.toString()}`}
                                position={'right'}
                            />
                        )}
                    </div>
                </>
            </Modal>
        </div>
    )
}
